import { render, staticRenderFns } from "./maintainanceTaskDetail.vue?vue&type=template&id=585e9cee&scoped=true"
import script from "./maintainanceTaskDetail.vue?vue&type=script&lang=js"
export * from "./maintainanceTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./maintainanceTaskDetail.vue?vue&type=style&index=0&id=585e9cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585e9cee",
  null
  
)

export default component.exports